<template>
  <div class="section-itis9-promotion">
    <div class="title">
      <y-text size="32px">{{ getI18nText(promotionData.titleI18n) }}</y-text>
    </div>
    <div class="promotion-content">
      <div class="text-content">
        <y-text class="subtitle">
          {{ getI18nText(promotionData.subtitleI18n) }}
        </y-text>

        <y-text class="description">
          {{ getI18nText(promotionData.descriptionI18n) }}
        </y-text>

        <y-button class="promotion-btn" @click="handlePromotionClick">
          {{ getI18nText(promotionData.buttonTextI18n) }}
        </y-button>
      </div>
      <el-image
        class="image-content"
        :src="promotionData.backgroundImage"
        fit="cover"
        lazy
      />
    </div>
  </div>
</template>

<script setup>
import { useYChannelStoreHook } from "@consumerY/store/channel";
import { computed } from "vue";

import { getI18nText } from "@/plugins/i18n";

const channelStore = useYChannelStoreHook();

const promotionData = computed(() => {
  return channelStore.configs?.pages?.Index?.specialPromotion || {};
});

const handlePromotionClick = () => {
  if (promotionData.value.buttonLink) {
    window.open(promotionData.value.buttonLink, "_blank");
  }
};

defineOptions({
  name: "Itis9Promotion"
});
</script>

<style lang="scss" scoped>
.section-itis9-promotion {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .title {
    --y-text-font-family: var(--y-title-font);
    margin-top: 90px;
    font-size: 50px;
    color: var(--y-text-color);
    text-align: center;
    margin-bottom: 48px;
    line-height: 1;
  }
  .promotion-content {
    width: 1080px;
    height: 370px;
    display: flex;
    .text-content {
      width: 50%;
      background-color: #faf7f3;
      padding: 56px 48px;
      .subtitle {
        font-family: var(--y-title-font);
        font-weight: bold;
        font-size: 24px;
        color: #44290d;
        line-height: 38px;
        white-space: pre-line;
      }
      .description {
        font-family: SourceHanSerifCN, SourceHanSerifCN;
        font-weight: 400;
        font-size: 16px;
        color: #696969;
        display: block;
        margin-top: 20px;
      }
      .promotion-btn {
        height: 40px;
        border: 1px solid #44290d;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 14px;
        color: #44290d;
        line-height: 20px;
        margin-top: 56px;
        background-color: transparent;
      }
      .promotion-btn:hover {
        background-color: #44290d;
        color: #faf7f3;
      }
    }
    .image-content {
      width: 50%;
    }
  }
}
</style>
